import React, { Component } from 'react';

class EditModa extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Diseño de Moda</div>
        );
    }
}
 
export default EditModa;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditModa.jsx